import { Link } from 'react-router-dom';

// project imports
import config from 'config';
import Logo from 'ui-components/Logo';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    return (
        <Link className="gd-logo" to={config.defaultPath}>
            <Logo imageSize={30} />
        </Link>
    );
};

export default LogoSection;
